import { render, staticRenderFns } from "./DigitalJournal.vue?vue&type=template&id=72da0f3b&"
import script from "./DigitalJournal.vue?vue&type=script&lang=js&"
export * from "./DigitalJournal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports